import { AnyObjectSchema } from 'yup';

import { GridLegacy, DialogContent, FormValues } from '@sbv-clients/ui-shared';

import { Form } from '../form/form';
import { SubmitActions } from './dynamic-form-actions';
import { DynamicField } from './dynamic-form-body';
import { buildSchemaFromFields } from './dynamic-form-schema';
import { prepareDefaultValues } from './prepare-default-values';

export interface DynamicFormProps {
  fields: any[];
  onSubmit: FormValues<any>['onSubmit'];
  onCancel: () => void;
  defaultValues?: Record<string, any>;
}

export function DynamicForm({
  fields,
  onSubmit,
  onCancel,
  defaultValues: userDefaultValues = {},
}: DynamicFormProps) {
  const schema = buildSchemaFromFields(fields) as AnyObjectSchema;
  const defaultValues = userDefaultValues || prepareDefaultValues(fields, {});
  return (
    <Form schema={schema} defaultValues={defaultValues} onSubmit={onSubmit}>
      <DialogContent>
        <GridLegacy container>
          {fields.map((f: any) => (
            <GridLegacy item xs={12} key={f.field}>
              <DynamicField fieldDef={f} />
            </GridLegacy>
          ))}
        </GridLegacy>
      </DialogContent>
      <SubmitActions onCancel={onCancel} />
    </Form>
  );
}
